import type { EventTypeEnum } from '../events/event-type.enum'
import type { Person } from '../persons/person'

export class TagEntity {
    tagId: string
    label: string
    companyId: string
    status: number
    eventType?: EventTypeEnum[]
    eventContent?: string
    eventTypeRemove?: EventTypeEnum[]
    eventContentRemove?: string
    expiresInDays?: number
    person?: Person
    createdAt: Date
    updatedAt: Date
    externalId?: string
}
